import 'pages/delivery/delivery-new-modal.tag'
riot.tag2('delivery', '  <catalog object="Delivery" cols="{cols}" allselect="true" reload="true" handlers="{handlers}" sortable="true" reorder="true" add="{permission(add, &quot;deliveries&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;deliveries&quot;, &quot;0001&quot;)}" dblclick="{permission(dOpen, &quot;deliveries&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name"><i class="fa {row.status == &quot;Y&quot; ? &quot;fa-eye&quot; : &quot;fa-eye-slash text-noactive&quot;}"></i> {row.name}</datatable-cell>\n      <datatable-cell name="code">{handlers.types[row.code]}</datatable-cell>\n      <datatable-cell name="period"><span> {row.period != 0 ? row.period : ⁗⁗}</span><span style="color: #ccc;">{row.period != 0 ? ⁗ дн.⁗ : ⁗⁗}</span></datatable-cell>\n      <datatable-cell name="price"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {parseInt(row.price).toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="note">{row.note}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Delivery';
self.handlers = {
    types: {
        simple: 'Простая доставка',
        region: 'Доставка по регионам',
        subregion: 'Доставка по регионам с подпункта',
        ems: 'EMS',
        post: 'Почта России',
        sdek: 'СДЭК'
    }
};

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'Тип' }, { name: 'period', value: 'Период' }, { name: 'price', value: 'Цена' }, { name: 'note', value: 'Примечание' }];

//self.add = () => riot.route('/products/delivery/new')

self.add = function (e) {
    e.stopPropagation();

    var id, item;
    if (e.item && e.item.id) {
        id = e.item.id;
        item = e.item;
    }

    modals.create('delivery-new-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (_this.name.value.toString().trim() != '' && !_this.error) {

                var params;
                params = { name: _this.name.value, code: 'simple' };

                API.request({
                    object: 'Delivery',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        _this.modalHide();
                        //childs.push(response)
                        popups.create({
                            title: 'Успех!',
                            text: 'Доставка добавлена',
                            style: 'popup-success'
                        });
                        self.update();
                        riot.route('/products/delivery/' + response.id);
                    }
                });
            }
        }
    });
};

self.dOpen = function (e) {
    return riot.route('/products/delivery/' + e.item.row.id);
};

self.one('updated', function () {
    self.tags.catalog.tags.datatable.on('reorder-end', function () {
        var _self$tags$catalog$pa = self.tags.catalog.pages,
            current = _self$tags$catalog$pa.current,
            limit = _self$tags$catalog$pa.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags.catalog.items.forEach(function (item, sort) {
            item.sort = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: 'Delivery',
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });
        self.update();
    });
});

self.on('mount', function () {
    /*API.request({
        object: 'DeliveryType',
        method: 'Fetch',
        success(response) {
            self.handlers.types = {}
            response.items.forEach(item => {
                self.handlers.types[item.id] = {
                    code: item.code,
                    name: item.name
                }
            })
        },
        error(response) {
            self.handlers.types = {}
        },
        complete() {
            self.update()
        }
    })*/
});

observable.on('delivery-reload', function () {
    self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/delivery/delivery.tag